/**
 * «إيقاف الوحدة» backend error codes. Must match `ErrorCodes` in be/utils/errors.js (Unit Stop group).
 * Codes are the contract; the backend's Arabic `error` is shown verbatim (it names the refusal).
 * Pattern reference: web/src/utils/arrivalErrorCodes.js
 */
export const UNIT_STOP_ERROR_CODES = {
  NOT_FOUND: 'UNIT_STOP_001',
  PROPERTY_NOT_FOUND: 'UNIT_STOP_002',
  ALREADY_ACTIVE: 'UNIT_STOP_003',
  ALREADY_RESOLVED: 'UNIT_STOP_004',
  REASON_INVALID: 'UNIT_STOP_005',
  NOTE_REQUIRED: 'UNIT_STOP_006',
  DATES_INVALID: 'UNIT_STOP_007',
  CLOSE_SHRINK: 'UNIT_STOP_008',
};
